import { render } from "./ProductsSection.vue?vue&type=template&id=7096ffa0"
import script from "./ProductsSection.vue?vue&type=script&lang=js"
export * from "./ProductsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__